import {
    URLAPI,
    CUSTODIAN_PATH,
    CUSTODIAN_CREATE_PATH,
    CUSTODIAN_UPDATE_PATH,
    CUSTODIAN_DELETE_PATH,
} from "../config/index";
import {LOGOUT} from './users';
import axios from "axios";

const init = {
    _get_all_custodian: {
        data: [],

        status: 0,
        message: {},
    },

    _create_custodian: {
        data: {},
        status: 0,
        message: {},
    },
    _update_custodian: {
        data: {},
        status: 0,
        message: {},
    },
    _delete_custodian: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_CUSTODIAN = "GET_ALL_CUSTODIAN";
export const CREATE_CUSTODIAN = "CREATE_CUSTODIAN";
export const UPDATE_CUSTODIAN = "UPDATE_CUSTODIAN";
export const DELETE_CUSTODIAN = "DELETE_CUSTODIAN";

export const custodian_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_CUSTODIAN:
            return {
                ...state,
                _get_all_custodian: action.payload,
            };
        case CREATE_CUSTODIAN:
            return {
                ...state,
                _create_custodian: action.payload,
            };
        case UPDATE_CUSTODIAN:
            return {
                ...state,
                _update_custodian: action.payload,
            };
        case DELETE_CUSTODIAN:
            return {
                ...state,
                _delete_custodian: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllCustodian = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${CUSTODIAN_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_CUSTODIAN,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_CUSTODIAN,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_CUSTODIAN,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

//create custodian
export const createCustodian = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${CUSTODIAN_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_CUSTODIAN,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_CUSTODIAN,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_CUSTODIAN,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateCustodian = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${CUSTODIAN_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_CUSTODIAN,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_CUSTODIAN,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_CUSTODIAN,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const deleteCustodian = (token, id) => async (dispatch) => {
    try {
        const response = await axios.delete(
            `${URLAPI}${CUSTODIAN_DELETE_PATH}${id}/`,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: DELETE_CUSTODIAN,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: DELETE_CUSTODIAN,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: DELETE_CUSTODIAN,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_custodian = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
